module.exports = __webpack_public_path__ + "img/CS-UL-HD_Overview-Roof_2.98492060.jpg";